export interface PaymentCondition {
    id?: number;
    name: string;
    is_active?: boolean;
}

export interface PaymentConditionDataForm {
    id?: number;
    name: string;
    is_active?: boolean;
}

export const defaultPaymentConditionDataForm: PaymentConditionDataForm = {
    name: '',
    is_active: true
};

export interface PaymentConditionFilters {
    id?: number | null;
    name?: string | '';
    is_active?: boolean | '';
    page: number;
    per_page: number;
    sort: string;
    order: string;
}
